import { useContext } from 'react';
import { ThemeContext } from '@danske/sapphire-react-context';

/**
 * Checks if Sapphire theme context is provided. Meant to be used only inside Sapphire components.
 * @private
 */
export const useThemeCheck = (): void => {
  const themeContext = useContext(ThemeContext);
  if (typeof themeContext.theme === undefined) {
    throw new Error(
      'A Sapphire component must be rendered inside a <SapphireProvider>.'
    );
  }
};
